import { defineFrontendModule } from '~/lib/module';

defineFrontendModule({
  name: 'ui',
  owner: 'cella',
  scope: ['frontend'],
  description: 'Core UI primitives, design system components, and styling utilities.',
});
